import React from 'react';
import styles from './css/index.module.css';
import { ACTIVITY_COLUMN_MIN_WIDTH } from './raciConstants';

const SKELETON_ROW_COUNT = 3;

const RaciMatrixEmptyState = ({
    readOnly,
    addingColumn,
    newColumnLabel,
    onNewColumnLabelChange,
    onCommitNewColumn,
    onCancelNewColumn,
    onAddActivity,
    onStartAddColumn,
}) => (
    <div className={styles.emptyStateScroll}>
        <table className={styles.emptyStateTable} role="presentation">
            <colgroup>
                <col style={{ minWidth: ACTIVITY_COLUMN_MIN_WIDTH, width: 300 }} />
                <col />
            </colgroup>
            <thead>
                <tr>
                    <th scope="col" className={styles.emptyStateHeaderActivity}>
                        Activity / Deliverable
                    </th>
                    <th scope="col" className={styles.emptyStateHeaderStakeholder}>
                        {addingColumn && !readOnly ? (
                            <input
                                className={styles.newColumnInput}
                                placeholder="Enter role, team or stakeholder"
                                value={newColumnLabel}
                                onChange={e => onNewColumnLabelChange(e.target.value)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        onCommitNewColumn();
                                    }
                                    if (e.key === 'Escape') {
                                        e.preventDefault();
                                        onCancelNewColumn();
                                    }
                                }}
                                onBlur={onCommitNewColumn}
                                autoFocus
                            />
                        ) : (
                            <div className={styles.emptyStateHeaderStakeholderInner}>
                                {!readOnly && (
                                    <button type="button" className={styles.emptyStateTextAction} onClick={onStartAddColumn}>
                                        + Add column
                                    </button>
                                )}
                                <span className={styles.emptyStateHeaderHint}>Role, team or stakeholder</span>
                            </div>
                        )}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr className={styles.emptyStateHeroRow}>
                    <td className={styles.emptyStateActivityCell}>
                        {!readOnly && (
                            <button type="button" className={styles.emptyStateTextAction} onClick={onAddActivity}>
                                + Add activity or deliverable
                            </button>
                        )}
                    </td>
                    <td className={styles.emptyStateHeroCell}>
                        <div className={styles.emptyStateHeroContent}>
                            <h2 className={styles.emptyStateTitle}>Build your RACI Matrix</h2>
                            <p className={styles.emptyStateDescription}>
                                Add activities down the left and roles, teams or stakeholders across the top. Then assign
                                R, A, C or I to each intersection.
                            </p>
                            {!readOnly && (
                                <div className={styles.emptyStateCtas}>
                                    <button type="button" className={styles.btnPrimary} onClick={onAddActivity}>
                                        + Add first activity
                                    </button>
                                    <button type="button" className={styles.emptyStateTextAction} onClick={onStartAddColumn}>
                                        Add a column
                                    </button>
                                </div>
                            )}
                        </div>
                    </td>
                </tr>
                {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
                    <tr key={index} className={styles.emptyStateSkeletonRow}>
                        <td className={styles.emptyStateSkeletonLeft} aria-hidden="true" />
                        <td className={styles.emptyStateSkeletonRight} aria-hidden="true" />
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default RaciMatrixEmptyState;
